import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-sign-in-detected.component.less'],
  templateUrl: './tellent-sign-in-detected.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    EmailMailgunIfDirective,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentSignInDetectedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentSignInDetectedTemplateData>;
}

export type TellentSignInDetectedTemplateData = {
  title: string;
  p1_html: string;
  p1_html_link: {
    label: string;
    href: string;
  };
  p1_wrap: {
    start: string;
    end: string;
  };
  p2_html: string;
  detail_1_html?: string;
  detail_2_html?: string;
  detail_3_html?: string;
  detail_4_html?: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
};

export const TellentSignInDetectedTemplateMocks: TellentSignInDetectedTemplateData[] = [
  {
    title: 'New sign-in detected',
    p1_html: `We have detected a new sign-in to your Tellent account <br>(<a href="%{url}">%{user_email}</a>).`,
    p1_html_link: {
      label: `%{user_email}`,
      href: `%{user_email}`,
    },
    p1_wrap: {
      start: '(',
      end: ').',
    },
    p2_html: `If this was you, you can ignore this message. If you don’t recognize this activity, please change your password immediately.<br /><br />We also recommend activating two-factor authentication (2FA) to increase account security and prevent unauthorized access.`,
    detail_1_html: '<b>Date and time:</b> 2023-06-13 08:07:20 UTC',
    detail_2_html: '<b>Device:</b> Chrome/MacOS',
    detail_3_html: '<b>IP Address:</b> 178.47.128.80',
    detail_4_html: '<b>Location:</b> Berlin, Germany',
    footer: {
      text: 'Need help?',
      href: 'support@tellent.com',
      label: 'Contact us',
    },
  },
];
